import logo from './logo.svg';
import './App.css';
import React, { useState, useEffect } from 'react';
import axios from 'axios';

function App() {

  const [data, setData] = useState([]);
  const [invested, setinvested ] = useState("");
  const [Loss, setLoss ] = useState("");
  const [totalSum, setTotalSum] = useState(0);
  const [Profit, setProfit] = useState(10);
  const [margincall, setmargincall] = useState('');
  const [points, setpoints] = useState([]);
  const [pattan, setpattan] = useState([2,4,8,16,2,4,8,16,2,4,8,16,2,4,8,16,2,4,8,16,2,4,8,16,2,4,8,16,2,4,8,16,2,4,8,16,2,4,8,16,2,4,8,16]);
  const [Below, setBelow] = useState(1);

  

  useEffect(() => {
    const pattern = [2, 4, 8, 16];
    const totalTerms = Loss;
    let sum = 0;

    for (let i = 0; i < totalTerms; i++) {
      sum += pattern[i % pattern.length];
    }

    setTotalSum(sum);
  }, [Loss,invested,Below]);
  

  useEffect(() => {
    axios.get('https://robotecheducation.com/api/recoverysapi')
      .then(response => {
        setpoints(response.data.recovery);
      })
      .catch(error => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    axios.get('https://robotecheducation.com/api/recoverys')
      .then(response => {
        setData(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  }, []);

  const grandTotal = pattan.reduce((sum, item, index) => {
    if (index < margincall) {
      return sum + (item * Profit);
    }
    return sum;
  }, 0);


  const rows = Array.from({ length: Math.round(Loss/2) }, (_, i) => {
    const pointData = points?.[(parseInt(margincall) + i + 1)];
    const pattValue = pattan?.[i] || 0;
    const total = pattValue * Profit || 0;
  
    return {
      point: pointData?.point || "-",
      value: pointData?.value || "-",
      pattValue,
      total,
    };
  });
  
  const subtotal = rows.reduce((acc, row) => acc + (isNaN(row.total) ? 0 : row.total), 0);


  return (
    <div className="App">
      <h5 style={{color:'blue',marginTop:'5%',padding:'2%'}}>ROBOTECH COIN  RECOVERY</h5>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Parameters</th>
            <th scope="col">Input Feed</th>

          </tr>
        </thead>
        <tbody>
        <tr>
            <th scope="row">1</th>
            <td><label for="exampleInputEmail1">Below 30% or Above 30%</label></td>
            <td><select onChange={(e) => setBelow(e.target.value)}  class="form-control" id="exampleFormControlSelect1">
              <option value={1}>Below 30% </option>
              <option value={2}>Above 30%</option>
             
            </select></td>
            </tr>

          <tr>
            <th scope="row">2</th>
            <td><label for="exampleInputEmail1">First Buy in Amount </label></td>
            <td>
                      <div class="form-group">
            <select onChange={(e) => setProfit(e.target.value)}  class="form-control" id="exampleFormControlSelect1">
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={20}>20</option>
              <option value={25}>25</option>
              <option value={30}>30</option>
              <option value={35}>35</option>
              <option value={40}>40</option>
            </select>
          </div>
              
              </td>
          </tr>
          <tr>
            <th scope="row">3</th>
            <td><label for="exampleInputEmail1"><b style={{color:'blue'}}>Marign Call Count</b></label></td>
            <td><input type="number" value={margincall}  
            onChange={(e) => {
              const value = e.target.value;
              if (value === "") {
                setmargincall("");
              } else if (Number(value) <= 30) {
                setmargincall(Number(value));
              }
            }}
  
   className="form-control" placeholder /></td>
          </tr>
          <tr>
            <th scope="row">4</th>
            <td><label for="exampleInputEmail1"><b style={{color:'red'}}>Position Amount in USDT</b></label></td>
            <td><input type="number" value={invested}  onChange={(e) => setinvested(e.target.value)}  className="form-control" placeholder /></td>
          </tr>
          <tr>
            <th scope="row">5</th>
            <td><label for="exampleInputEmail1"><b style={{color:'red'}}>Current U/L Precentage</b></label></td>
            <td><input type="number" value={Loss}  onChange={(e) => setLoss(e.target.value)} className="form-control" placeholder /></td>
          </tr>
          <tr>
            <th scope="row">6</th>
            <td><label for="exampleInputEmail1"><>Manual Buy Requirement </></label></td>
            <td><input type="text" value={invested * Below} readOnly className="form-control" placeholder /></td>
          </tr>
          <tr>
            <th scope="row">7</th>
            <td><label for="exampleInputEmail1"><>Reduced U/L Percentage 	</></label></td>
            <td><input type="text" value={Math.round(Loss/2)} readOnly className="form-control" placeholder /></td>
          </tr>

          <tr>
            <th scope="row">8</th>
            <td><label for="exampleInputEmail1"><>Addtional Marign Call Requirement</></label></td>
            <td><input type="text" value={Math.round(Loss/2)} readOnly className="form-control" placeholder /></td>
          </tr>
          <tr>
            <th scope="row">9</th>
            <td><label for="exampleInputEmail1"><>Total Fund Required in USDT for Margin Call Execution</></label></td>
            <td><h3>{(parseFloat(invested * Below) +  parseFloat(subtotal))}</h3></td>
          </tr>
          {/* <tr>
            <th scope="row">8</th>
            <td><label for="exampleInputEmail1"><>Total Fund Requried for Executing Recovery  </></label></td>
            <td><h2 style={{color:'red'}}>{ (parseFloat(invested) + parseFloat(((Loss/2) / data?.recoverys?.flaotingloss ) * subtotal))}</h2></td>
          </tr> */}
        </tbody>
      </table>
      <br></br>
      <table className="table table-bordered">
  <thead>
    <tr>
      <th>Addtional Marign Call</th>
      <th>Margin Call Drop</th>
      <th>Multiple Buy in Ratio</th>
      <th>Usdt</th>
    </tr>
  </thead>

  <tbody>
  {Array.from({ length: Math.round(Loss/2) }, (_, i) => (
  <tr key={i}>
    <td>{margincall + i + 1}</td>
    <td>{points?.[(parseInt(margincall -1) + i)]?.value || "-"}%</td>
    <td>{(pattan?.[i])|| "-"}</td> 
    <td>{(pattan?.[i] * Profit)|| "-"}</td> 
  </tr>
))}
{/* <tr>
  <td></td>
  <td></td>
  <td>{grandTotal}</td>
</tr> */}
  </tbody>
</table>


      
    </div>
  );
}

export default App;
